export default __webpack_public_path__ + "d8d2ddd02a2781719fd303dc4b868ac0.gif";